// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47a3a412","455":"2e3b13a1","977":"2eed67d9"}[chunkId] + ".chunk.js";
};